module.exports = __webpack_public_path__ + "assets/be240e43dd6cba1d6582182d74b3afb2.jpg";